module.exports = __webpack_public_path__ + "static/media/before.cff1b6d6.svg";